// extracted by mini-css-extract-plugin
export default {"heroImageWithText":"HeroImageWithText_heroImageWithText__h1qtl","heroImageWithTextContent":"HeroImageWithText_heroImageWithTextContent__9u8xu"};